import React from 'react';
import MaterialSelect from './materialSelect';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';


const SelectOptionPage = ({
    selections,
    onChange,
    selected,
    showPrices,
    prices,  
    selectioDescription,
    infoText,
    nextPage,
    prevPage,
    hideHeader}) => {
    return (<div className="page modelDescription">
        <SaunaImageContainer />
        {infoTextContainer(infoText)}
        <h1 className="modelDescription" >{selected}</h1>
        <p>{selectioDescription}</p>
        <div className="materialSelections">
            <Row>
                <Col md={12} sm={12}><MaterialSelect materials={selections} autoAdjustWidth={true} columnNum={3} onChange={onChange} hideSelectionName={true} selected={selected} showPrices={showPrices} prices={prices} hideHeader={hideHeader} />
                </Col>
            </Row>
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
        </div>
    </div>
    )
}
export default SelectOptionPage



let infoTextContainer = (text) => {
    if (text) {
        return (
            <div id="notification" className="notification" onClick={() => document.getElementById('notification').classList.add("hiddenNotification")}>
                <span>{text}</span>           
            </div>
        );
    }
    else {
        return "";
    }

}
